/* Wide Angle cart: the free-delivery bar in the cart drawer and on the cart page.
 *
 * Loaded only when the preview gate is on (snippets/cart-drawer.liquid). The
 * threshold comes from settings.cart_free_shipping_threshold via #WaCartConfig,
 * never from this file.
 *
 * Why a script: cart-drawer.js and cart.js re-render the drawer and the cart
 * page through the Section Rendering API after every change, and those renders
 * never see the preview template, so gated markup cannot live inside them. The
 * drawer already prints its own free-delivery message; this adds the bar under
 * it after each render. The cart page box (main-cart-footer) sits outside the
 * re-rendered block and is updated here.
 */
(function () {
  if (window.__waCart) return;
  window.__waCart = true;

  var cfg = { threshold: 0, total: 0 };
  try {
    var el = document.getElementById('WaCartConfig');
    if (el) cfg = Object.assign(cfg, JSON.parse(el.textContent));
  } catch (e) { /* keep defaults: no bar */ }
  var threshold = +cfg.threshold || 0;
  var total = +cfg.total || 0;
  var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function pct() { return Math.max(0, Math.min(100, (total / threshold) * 100)); }

  /* Totals print with money_with_currency ("£18.00 GBP") in the customer markup;
     Wide Angle shows prices with the plain money format, so drop the code. */
  var codeRe = new RegExp('\\s*' + code + '\\s*$');
  function stripCodes() {
    var els = document.querySelectorAll('#CartDrawer .totals__total-value, #main-cart-footer .totals__total-value');
    for (var i = 0; i < els.length; i++) {
      var t = els[i].textContent;
      if (codeRe.test(t)) els[i].textContent = t.replace(codeRe, '').trim();
    }
  }

  function drawDrawer() {
    if (!threshold) return;
    var box = document.querySelector('#CartDrawer .cart-drawer__threshold');
    if (!box) return;
    var bar = box.querySelector('.wa-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'wa-bar';
      bar.setAttribute('aria-hidden', 'true');
      bar.appendChild(document.createElement('i'));
      box.appendChild(bar);
    }
    var w = pct().toFixed(1) + '%';
    if (bar.firstChild.style.width !== w) bar.firstChild.style.width = w;
    box.classList.toggle('is-clear', total >= threshold);
  }

  function drawPage() {
    if (!threshold) return;
    var box = document.querySelector('[data-wa-cart-ship]');
    if (!box) return;
    box.hidden = total <= 0;
    var msg = box.querySelector('[data-wa-ship-msg]');
    var bar = box.querySelector('[data-wa-ship-bar]');
    if (bar) bar.style.width = pct().toFixed(1) + '%';
    if (msg) {
      msg.textContent = total >= threshold
        ? box.dataset.msgAbove
        : (box.dataset.msgBelow || '').replace('[amount]', money(threshold - total));
    }
    box.classList.toggle('is-clear', total >= threshold);
  }

  function draw() { drawDrawer(); drawPage(); }

  function refresh() {
    return fetch((window.routes && routes.cart_url ? routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.total_price || 0; draw(); })
      .catch(function () { /* leave the last known bar */ });
  }

  function init() {
    draw();
    stripCodes();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    /* The drawer and the cart page totals replace their insides on every change,
       taking the bar and the tidied total with them. */
    if (!window.MutationObserver) return;
    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; drawDrawer(); stripCodes(); });
    });
    ['cart-drawer', '#main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) mo.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
